/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DeletePaymentsCommand } from '../models/delete-payments-command';
import { EmployerRelationshipData } from '../models/employer-relationship-data';
import { ExportPaymentSummaryExpandedQuery } from '../models/export-payment-summary-expanded-query';
import { ExportPaymentSummaryQuery } from '../models/export-payment-summary-query';
import { ExportPaymentSummaryWorkdayQuery } from '../models/export-payment-summary-workday-query';
import { ExportPaymentsByEmployerQuery } from '../models/export-payments-by-employer-query';
import { ExportPaymentsRecordByRecordQuery } from '../models/export-payments-record-by-record-query';
import { ImportPaymentCommand } from '../models/import-payment-command';
import { ImportedLineResult } from '../models/imported-line-result';
import { ListPaymentsQuery } from '../models/list-payments-query';
import { ListPaymentsResult } from '../models/list-payments-result';
import { PaymentSchedule } from '../models/payment-schedule';
import { PaymentType } from '../models/payment-type';
import { UserState } from '../models/user-state';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation paymentList
   */
  static readonly PaymentListPath = '/api/Payment/List';

  /**
   * Fizetések listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentList$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentList$Plain$Response(params?: {
    body?: ListPaymentsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListPaymentsResult>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListPaymentsResult>;
      })
    );
  }

  /**
   * Fizetések listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentList$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentList$Plain(params?: {
    body?: ListPaymentsQuery
  },
  context?: HttpContext

): Observable<ListPaymentsResult> {

    return this.paymentList$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListPaymentsResult>) => r.body as ListPaymentsResult)
    );
  }

  /**
   * Fizetések listázása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentList()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentList$Response(params?: {
    body?: ListPaymentsQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ListPaymentsResult>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentListPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ListPaymentsResult>;
      })
    );
  }

  /**
   * Fizetések listázása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentList$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentList(params?: {
    body?: ListPaymentsQuery
  },
  context?: HttpContext

): Observable<ListPaymentsResult> {

    return this.paymentList$Response(params,context).pipe(
      map((r: StrictHttpResponse<ListPaymentsResult>) => r.body as ListPaymentsResult)
    );
  }

  /**
   * Path part for operation paymentPost
   */
  static readonly PaymentPostPath = '/api/Payment/Post';

  /**
   * Fizetés létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  paymentPost$Response(params?: {
    body?: {
'Id'?: number;
'RequestUserId'?: number;
'ProfilePicture'?: string;
'UserId'?: number;
'MCode'?: string;
'Name'?: string;
'UserState'?: UserState;
'EmployerId'?: number;
'Employer.Id'?: number;
'Employer.Name'?: string;
'Employer.Active'?: boolean;
'Employer.Email'?: string;
'Employer.EmployerRelationships'?: Array<EmployerRelationshipData>;
'EmployerName'?: string;
'RecruiterId'?: number;
'Recruiter.Id'?: number;
'Recruiter.Name'?: string;
'Recruiter.Active'?: boolean;
'Recruiter.Email'?: string;
'Recruiter.EmployerRelationships'?: Array<EmployerRelationshipData>;
'RecruiterName'?: string;
'EmployerRelationshipId'?: number;
'EmployerRelationship.Id'?: number;
'EmployerRelationship.Name'?: string;
'EmployerRelationship.Active'?: boolean;
'EmployerRelationshipName'?: string;
'Date'?: string;
'DateUtc'?: string;
'TimeZoneId'?: string;
'LabelId'?: number;
'Label'?: string;
'Company'?: string;
'EventInfo'?: string;

/**
 * Funkció
 */
'Function'?: string;

/**
 * Utazási idő
 */
'TravelTime'?: number;

/**
 * Úti bér [Ft/óra]
 */
'TravelCostPerHour'?: number;

/**
 * Utazási bér
 */
'TravelCost'?: number;

/**
 * Távolság
 */
'Distance'?: number;

/**
 * Úti bér [Ft/km]
 */
'TravelCostPerKm'?: number;

/**
 * Pontosság
 */
'Accuracy'?: number;

/**
 * Teljesítmény
 */
'Performance'?: number;

/**
 * Bérkód
 */
'WageCode'?: string;

/**
 * Órabér
 */
'HourlyWage'?: number;

/**
 * Munkaidő
 */
'WorkingHours'?: number;

/**
 * Munkabér
 */
'Wage'?: number;

/**
 * Fizetés
 */
'Payment'?: number;
'PaymentType'?: PaymentType;

/**
 * Megjegyzés
 */
'Description'?: string;
'PaymentSchedule'?: PaymentSchedule;
'CreateUserMCode'?: string;
'CreateUserProfilePicture'?: string;
'IsNotified'?: boolean;
'Editable'?: boolean;
'LastChangeDate'?: string;
'TaxNumber'?: string;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Fizetés létrehozása vagy módosítása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  paymentPost(params?: {
    body?: {
'Id'?: number;
'RequestUserId'?: number;
'ProfilePicture'?: string;
'UserId'?: number;
'MCode'?: string;
'Name'?: string;
'UserState'?: UserState;
'EmployerId'?: number;
'Employer.Id'?: number;
'Employer.Name'?: string;
'Employer.Active'?: boolean;
'Employer.Email'?: string;
'Employer.EmployerRelationships'?: Array<EmployerRelationshipData>;
'EmployerName'?: string;
'RecruiterId'?: number;
'Recruiter.Id'?: number;
'Recruiter.Name'?: string;
'Recruiter.Active'?: boolean;
'Recruiter.Email'?: string;
'Recruiter.EmployerRelationships'?: Array<EmployerRelationshipData>;
'RecruiterName'?: string;
'EmployerRelationshipId'?: number;
'EmployerRelationship.Id'?: number;
'EmployerRelationship.Name'?: string;
'EmployerRelationship.Active'?: boolean;
'EmployerRelationshipName'?: string;
'Date'?: string;
'DateUtc'?: string;
'TimeZoneId'?: string;
'LabelId'?: number;
'Label'?: string;
'Company'?: string;
'EventInfo'?: string;

/**
 * Funkció
 */
'Function'?: string;

/**
 * Utazási idő
 */
'TravelTime'?: number;

/**
 * Úti bér [Ft/óra]
 */
'TravelCostPerHour'?: number;

/**
 * Utazási bér
 */
'TravelCost'?: number;

/**
 * Távolság
 */
'Distance'?: number;

/**
 * Úti bér [Ft/km]
 */
'TravelCostPerKm'?: number;

/**
 * Pontosság
 */
'Accuracy'?: number;

/**
 * Teljesítmény
 */
'Performance'?: number;

/**
 * Bérkód
 */
'WageCode'?: string;

/**
 * Órabér
 */
'HourlyWage'?: number;

/**
 * Munkaidő
 */
'WorkingHours'?: number;

/**
 * Munkabér
 */
'Wage'?: number;

/**
 * Fizetés
 */
'Payment'?: number;
'PaymentType'?: PaymentType;

/**
 * Megjegyzés
 */
'Description'?: string;
'PaymentSchedule'?: PaymentSchedule;
'CreateUserMCode'?: string;
'CreateUserProfilePicture'?: string;
'IsNotified'?: boolean;
'Editable'?: boolean;
'LastChangeDate'?: string;
'TaxNumber'?: string;
}
  },
  context?: HttpContext

): Observable<void> {

    return this.paymentPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation paymentDelete
   */
  static readonly PaymentDeletePath = '/api/Payment/Delete';

  /**
   * Kijelölt fizetések törlése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentDelete$Response(params?: {
    body?: DeletePaymentsCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentDeletePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Kijelölt fizetések törlése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentDelete(params?: {
    body?: DeletePaymentsCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.paymentDelete$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation paymentImport
   */
  static readonly PaymentImportPath = '/api/Payment/Import';

  /**
   * Fizetések importálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentImport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentImport$Plain$Response(params?: {
    body?: ImportPaymentCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ImportedLineResult>>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentImportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ImportedLineResult>>;
      })
    );
  }

  /**
   * Fizetések importálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentImport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentImport$Plain(params?: {
    body?: ImportPaymentCommand
  },
  context?: HttpContext

): Observable<Array<ImportedLineResult>> {

    return this.paymentImport$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ImportedLineResult>>) => r.body as Array<ImportedLineResult>)
    );
  }

  /**
   * Fizetések importálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentImport()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentImport$Response(params?: {
    body?: ImportPaymentCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<ImportedLineResult>>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentImportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ImportedLineResult>>;
      })
    );
  }

  /**
   * Fizetések importálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentImport$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentImport(params?: {
    body?: ImportPaymentCommand
  },
  context?: HttpContext

): Observable<Array<ImportedLineResult>> {

    return this.paymentImport$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<ImportedLineResult>>) => r.body as Array<ImportedLineResult>)
    );
  }

  /**
   * Path part for operation paymentExportRecordByRecord
   */
  static readonly PaymentExportRecordByRecordPath = '/api/Payment/ExportRecordByRecord';

  /**
   * Fizetések rekordonként exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportRecordByRecord$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportRecordByRecord$Plain$Response(params?: {
    body?: ExportPaymentsRecordByRecordQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportRecordByRecordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések rekordonként exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportRecordByRecord$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportRecordByRecord$Plain(params?: {
    body?: ExportPaymentsRecordByRecordQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportRecordByRecord$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Fizetések rekordonként exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportRecordByRecord()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportRecordByRecord$Response(params?: {
    body?: ExportPaymentsRecordByRecordQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportRecordByRecordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések rekordonként exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportRecordByRecord$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportRecordByRecord(params?: {
    body?: ExportPaymentsRecordByRecordQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportRecordByRecord$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation paymentExportRecordByRecordCsv
   */
  static readonly PaymentExportRecordByRecordCsvPath = '/api/Payment/ExportRecordByRecordCsv';

  /**
   * Fizetések rekordonként exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportRecordByRecordCsv$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportRecordByRecordCsv$Plain$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    StartDateDaysOffset?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportRecordByRecordCsvPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('StartDateDaysOffset', params.StartDateDaysOffset, {});
      rb.query('Labels', params.Labels, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések rekordonként exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportRecordByRecordCsv$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportRecordByRecordCsv$Plain(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    StartDateDaysOffset?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportRecordByRecordCsv$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Fizetések rekordonként exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportRecordByRecordCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportRecordByRecordCsv$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    StartDateDaysOffset?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportRecordByRecordCsvPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('StartDateDaysOffset', params.StartDateDaysOffset, {});
      rb.query('Labels', params.Labels, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések rekordonként exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportRecordByRecordCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportRecordByRecordCsv(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    StartDateDaysOffset?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportRecordByRecordCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation paymentExportByEmployer
   */
  static readonly PaymentExportByEmployerPath = '/api/Payment/ExportByEmployer';

  /**
   * Fizetések munkáltatói exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportByEmployer$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportByEmployer$Plain$Response(params?: {
    body?: ExportPaymentsByEmployerQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportByEmployerPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések munkáltatói exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportByEmployer$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportByEmployer$Plain(params?: {
    body?: ExportPaymentsByEmployerQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportByEmployer$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Fizetések munkáltatói exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportByEmployer()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportByEmployer$Response(params?: {
    body?: ExportPaymentsByEmployerQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportByEmployerPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések munkáltatói exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportByEmployer$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportByEmployer(params?: {
    body?: ExportPaymentsByEmployerQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportByEmployer$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation paymentExportSummary
   */
  static readonly PaymentExportSummaryPath = '/api/Payment/ExportSummary';

  /**
   * Fizetések összesítő exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummary$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummary$Plain$Response(params?: {
    body?: ExportPaymentSummaryQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummary$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummary$Plain(params?: {
    body?: ExportPaymentSummaryQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummary$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Fizetések összesítő exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummary()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummary$Response(params?: {
    body?: ExportPaymentSummaryQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummary$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummary(params?: {
    body?: ExportPaymentSummaryQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummary$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation paymentExportSummaryCsv
   */
  static readonly PaymentExportSummaryCsvPath = '/api/Payment/ExportSummaryCsv';

  /**
   * Fizetések összesítő exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryCsv$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryCsv$Plain$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryCsvPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('MinimalWorkingHours', params.MinimalWorkingHours, {});
      rb.query('Labels', params.Labels, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryCsv$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryCsv$Plain(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryCsv$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Fizetések összesítő exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryCsv$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryCsvPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('MinimalWorkingHours', params.MinimalWorkingHours, {});
      rb.query('Labels', params.Labels, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryCsv(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation paymentExportSummaryExpanded
   */
  static readonly PaymentExportSummaryExpandedPath = '/api/Payment/ExportSummaryExpanded';

  /**
   * Fizetések összesítő (bővített) exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryExpanded$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummaryExpanded$Plain$Response(params?: {
    body?: ExportPaymentSummaryExpandedQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryExpandedPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő (bővített) exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryExpanded$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummaryExpanded$Plain(params?: {
    body?: ExportPaymentSummaryExpandedQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryExpanded$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Fizetések összesítő (bővített) exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryExpanded()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummaryExpanded$Response(params?: {
    body?: ExportPaymentSummaryExpandedQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryExpandedPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő (bővített) exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryExpanded$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummaryExpanded(params?: {
    body?: ExportPaymentSummaryExpandedQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryExpanded$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation paymentExportSummaryExpandedCsv
   */
  static readonly PaymentExportSummaryExpandedCsvPath = '/api/Payment/ExportSummaryExpandedCsv';

  /**
   * Fizetések összesítő (bővített) exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryExpandedCsv$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryExpandedCsv$Plain$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryExpandedCsvPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('MinimalWorkingHours', params.MinimalWorkingHours, {});
      rb.query('Labels', params.Labels, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő (bővített) exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryExpandedCsv$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryExpandedCsv$Plain(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryExpandedCsv$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Fizetések összesítő (bővített) exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryExpandedCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryExpandedCsv$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryExpandedCsvPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('MinimalWorkingHours', params.MinimalWorkingHours, {});
      rb.query('Labels', params.Labels, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő (bővített) exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryExpandedCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryExpandedCsv(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryExpandedCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation paymentExportSummaryWorkday
   */
  static readonly PaymentExportSummaryWorkdayPath = '/api/Payment/ExportSummaryWorkday';

  /**
   * Fizetések összesítő (munkanap) exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryWorkday$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummaryWorkday$Plain$Response(params?: {
    body?: ExportPaymentSummaryWorkdayQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryWorkdayPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő (munkanap) exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryWorkday$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummaryWorkday$Plain(params?: {
    body?: ExportPaymentSummaryWorkdayQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryWorkday$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Fizetések összesítő (munkanap) exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryWorkday()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummaryWorkday$Response(params?: {
    body?: ExportPaymentSummaryWorkdayQuery
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryWorkdayPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő (munkanap) exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryWorkday$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  paymentExportSummaryWorkday(params?: {
    body?: ExportPaymentSummaryWorkdayQuery
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryWorkday$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation paymentExportSummaryWorkdayCsv
   */
  static readonly PaymentExportSummaryWorkdayCsvPath = '/api/Payment/ExportSummaryWorkdayCsv';

  /**
   * Fizetések összesítő (munkanap) exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryWorkdayCsv$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryWorkdayCsv$Plain$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    StartDateDaysOffset?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryWorkdayCsvPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('MinimalWorkingHours', params.MinimalWorkingHours, {});
      rb.query('StartDateDaysOffset', params.StartDateDaysOffset, {});
      rb.query('Labels', params.Labels, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő (munkanap) exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryWorkdayCsv$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryWorkdayCsv$Plain(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    StartDateDaysOffset?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryWorkdayCsv$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Fizetések összesítő (munkanap) exportálása.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentExportSummaryWorkdayCsv()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryWorkdayCsv$Response(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    StartDateDaysOffset?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentExportSummaryWorkdayCsvPath, 'get');
    if (params) {
      rb.query('TranslationLanguageCode', params.TranslationLanguageCode, {});
      rb.query('RequestUserId', params.RequestUserId, {});
      rb.query('APIKey', params.APIKey, {});
      rb.query('DateFrom', params.DateFrom, {});
      rb.query('DateTo', params.DateTo, {});
      rb.query('MinimalWorkingHours', params.MinimalWorkingHours, {});
      rb.query('StartDateDaysOffset', params.StartDateDaysOffset, {});
      rb.query('Labels', params.Labels, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Fizetések összesítő (munkanap) exportálása.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentExportSummaryWorkdayCsv$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentExportSummaryWorkdayCsv(params?: {
    TranslationLanguageCode?: string;
    RequestUserId?: number;
    APIKey?: string;
    DateFrom?: string;
    DateTo?: string;
    MinimalWorkingHours?: number;
    StartDateDaysOffset?: number;
    Labels?: Array<string>;
  },
  context?: HttpContext

): Observable<Blob> {

    return this.paymentExportSummaryWorkdayCsv$Response(params,context).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation paymentUpdateUserStatistics
   */
  static readonly PaymentUpdateUserStatisticsPath = '/api/Payment/UpdateUserStatistics';

  /**
   * Összes felhasználó Cég/Egység szerinti statisztikájának frissítése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `paymentUpdateUserStatistics()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentUpdateUserStatistics$Response(params?: {
    APIKey?: string;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaymentService.PaymentUpdateUserStatisticsPath, 'post');
    if (params) {
      rb.query('APIKey', params.APIKey, {});
      rb.query('RequestUserId', params.RequestUserId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Összes felhasználó Cég/Egység szerinti statisztikájának frissítése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `paymentUpdateUserStatistics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  paymentUpdateUserStatistics(params?: {
    APIKey?: string;
    RequestUserId?: number;
  },
  context?: HttpContext

): Observable<void> {

    return this.paymentUpdateUserStatistics$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
